import can from 'can/view/view';
import Component from 'can/component/component';
import template from './modal-photo-gallery.stache';
import List from 'scripts/models/base/list';
import appContext from 'scripts/app-context';
import Cloudinary from 'scripts/utils/cloudinary';
import DomEventsManager from 'scripts/dom-events-manager';
import Swiper from 'swiper';

const googleAds = window.globalSettings.galleryAds;
import { sendPhotoGallerySwipeAnalitycs } from './controllers/analitycs.controller';
import { adsMap } from 'components/dfp-advert-unit/dfp-advert-unit';
import device from 'scripts/utils/device';

const THUMBS_SLIDE_SPACE = 7;

const Model = can.Map.extend({
    component: null,
    element: null,
    imageTitle: null,
    imageIndex: null,
    imageIndexMessage: null,
    galleryTop: null,
    galleryTopContainer: null,
    galleryThumbs: null,
    galleryThumbsContainer: null,
    galleryThumbsWrapper: null,
    slidesCount: 0,
    visible: false,
    define: {
        active: {
            type: 'htmlbool',
            value: false,
        },
        photos: {
            Type: List,
            Value: List,
        },
        tags: {
            Type: List,
            Value: List,
        },
        galleryTitle: {
            type: 'string',
            value: '',
        },
        galleryUrl: {
            type: 'string',
            value: '',
        },
        activeSlideIndex: {
            type: 'number',
            value: 0,
        },
        activeSlide: {
            type: '*',
        },
        activeIndex: {
            type: 'number',
            value: 0,
        },
        isAdsAdded: {
            type: 'boolean',
            value: false,
        },
        shareImage: {
            get: function() {
                const activeSlide = this.attr('activeSlide');

                if (activeSlide && activeSlide.image) {
                    return Cloudinary.getImagePath(
                        activeSlide.image.identifier,
                    );
                }

                return '';
            },
        },
        shareUrl: {
            get: function() {
                const baseUrl = this.attr('galleryUrl');
                const activeSlideIndex = this.attr('activeSlideIndex');

                return (
                    baseUrl.split('#')[0] +
                    (activeSlideIndex > 0
                        ? can.route.url({ slide: activeSlideIndex })
                        : '')
                );
            },
        },
    },

    hide() {
        if (!this.active) {
            return;
        }

        if (this.galleryTop) {
            this.galleryTop.destroy(true);
        }
        if (this.galleryThumbs) {
            this.galleryThumbs.destroy(true);
        }

        can.remove(this.component);

        this.attr('component', null);
        this.attr('active', false);

        this.dispatch('modalClosed', []);
        appContext.model.dispatch('page-scroll-toggle', [false]);
    },

    initTopSwiper() {
        if (
            googleAds &&
            googleAds.id &&
            !adsMap.get(googleAds.id) &&
            !device.isTouch
        ) {
            this.insertAds(googleAds);
        }

        this.galleryTop = new Swiper(this.galleryTopContainer, {
            initialSlide: this.attr('activeIndex'),
            spaceBetween: 0,
            preventClicks: false,
            observer: true,
            zoom: {
                toggle: false,
            },
            keyboard: true,
            navigation: {
                prevEl: this.galleryTopContainer.find('.swiper-button-prev'),
                nextEl: this.galleryTopContainer.find('.swiper-button-next'),
            },
        });

        this.galleryTop.on('transitionEnd', () => {
            this.handleTransitionEnd(this.galleryTop);
        });

        this.galleryTop.on('slideChangeTransitionStart', () => {
            this.attr('activeIndex', this.galleryTop.activeIndex);
        });

        document
            .getElementsByTagName('body')[0]
            .addEventListener('slidetransitionend', () => this.trapFocus());
    },

    hideFocusHiddenSlides() {
        this.galleryThumbsContainer
            .find('.swiper-slide')
            .attr('tabindex', '-1');
        this.galleryThumbsContainer
            .find('.swiper-slide-visible')
            .attr('tabindex', '0');
    },

    initThumbsSwiper() {
        this.galleryThumbs = new Swiper(this.galleryThumbsContainer, {
            spaceBetween: THUMBS_SLIDE_SPACE,
            slidesPerView: 'auto',
            slidesPerGroup: 2,
            observer: true,
            navigation: {
                prevEl: this.galleryThumbsWrapper.find('.swiper-button-prev'),
                nextEl: this.galleryThumbsWrapper.find('.swiper-button-next'),
            },
            touchRatio: 0.2,
            freeMode: true,
            slideToClickedSlide: false,
            watchSlidesVisibility: true,
            on: {
                init: () => {
                    this.hideFocusHiddenSlides();
                    this.trapFocus();
                },
                slideChangeTransitionEnd: () => {
                    this.hideFocusHiddenSlides();
                    this.trapFocus();
                    if (
                        !this.galleryThumbsWrapper
                            .find('.swiper-button-next')
                            .is(':visible')
                    ) {
                        this.galleryThumbsWrapper
                            .find('.swiper-button-prev')
                            .focus();
                    }
                },
            },
        });

        this.updateGalleryThumbsSlides(this.galleryTop.activeIndex);
    },

    getAdIndex(ads) {
        const adsIndex = Number(ads.slideNum) - 1;
        const galleryLength = this.attr('photos.length') - 1;
        return adsIndex > galleryLength ? galleryLength : adsIndex;
    },
    insertAds(ads) {
        if (!ads) {
            return;
        }

        const index = this.getAdIndex(ads);
        if (this.attr('isAdsAdded')) {
            return;
        }

        const view = can.stache(
            `
            <div class='swiper-dfp-container'>
                <dfp-advert-unit
                    reload-interval='{{reloadInterval}}'
                    ad-unit-path='{{adUnitPath}}'
                    {sizes}='sizes'
                    {responsive}='responsive'
                    (didnotrender)="onAdDidNotRender()"
                />
            </div>
                    `,
        )({
            sizes: ads.sizes,
            adUnitPath: ads.id,
            responsive: true,
            reloadInterval: 5,
            onAdDidNotRender: () => this.removeAd(),
        });

        can.$(`<div class='swiper-slide ad' />`)
            .append(view)
            .insertAfter(
                this.galleryTopContainer.find('.swiper-slide').eq(index),
            );

        can.$(`<div class='swiper-slide ad hidden' />`).insertAfter(
            this.galleryThumbsContainer.find('.swiper-slide').eq(index),
        );

        this.attr('isAdsAdded', true);

        setTimeout(() => {
            this.galleryTopContainer
                .find('.swiper-slide')
                .find('.swiper-dfp-container')
                .addClass('hidden-ads');
        }, 3000);
    },

    handleTransitionEnd(swiper) {
        const activeIndex = this.activeIndex;
        const galleryTitle = this.attr('galleryTitle');
        const slideCaption = this.attr(`photos.${swiper.realIndex}.caption`);
        const slideImageId = this.attr(
            `photos.${swiper.realIndex}.image.identifier`,
        );

        if (this.galleryThumbs) {
            this.galleryThumbs.slideTo(activeIndex);
        }

        this.updateGalleryThumbsSlides(activeIndex);
        this.setActiveSlide(activeIndex);
        sendPhotoGallerySwipeAnalitycs(
            galleryTitle,
            slideImageId,
            slideCaption,
            swiper.realIndex + 1,
        );
    },

    updateGalleryThumbsSlides(activeIndex) {
        let index = parseInt(activeIndex);

        index = isNaN(index) ? 0 : index;

        this.galleryThumbsContainer
            .find('.expanded-slide')
            .removeClass('expanded-slide');
        this.galleryThumbsContainer
            .find('.swiper-slide')
            .eq(index)
            .addClass('expanded-slide');
    },

    setActiveSlide(slide) {
        const index = this.galleryTopContainer
            .find('.swiper-slide')
            .eq(slide)
            .data('slide-id');

        if (_.isNil(index)) {
            this.imageTitle.text('');
            this.imageIndex.text('');
            this.imageIndexMessage.text('');
        }

        let imageData = this.photos[index];

        if (!imageData) {
            return;
        }

        let imageCaption = imageData.caption || '';

        if (imageCaption.length > 260) {
            imageCaption = imageCaption.substring(0, 260) + '...';
        }

        this.imageTitle.text(imageCaption);
        this.imageIndex.text(`${index + 1} of ${this.slidesCount}`);
        this.imageIndexMessage.text(`Item ${index + 1} of ${this.slidesCount}`);
        this.attr('activeSlideIndex', index);
        this.attr('activeSlide', this.photos[index]);
        if (this.slidesCount === 1) {
            this.imageIndex.addClass('single-slide');
        }
    },

    thumbnailsToggle(stateOverride) {
        this.showThumbnails =
            stateOverride !== undefined ? stateOverride : !this.showThumbnails;
        this.element.toggleClass('thumbnails-shown', this.showThumbnails);
        this.element
            .find('.js-thumbs')
            .attr('aria-expanded', this.showThumbnails);
        this.showThumbnails
            ? this.galleryThumbsWrapper.slideDown({
                  duration: 150,
                  easing: 'linear',
              })
            : this.galleryThumbsWrapper.slideUp({
                  duration: 150,
                  easing: 'linear',
              });
        this.updateThumbsSlider();
        this.galleryThumbsWrapper
            .find('image-cloudinary')
            .each((i, component) => {
                can.$(component)
                    .viewModel()
                    .recalculateSize(component);
                can.$(component)
                    .viewModel()
                    .show();
            });
    },

    getCurrentSlideIndex() {
        let slide = this.galleryTop ? this.galleryTop.activeIndex : 0;

        if (isNaN(slide)) {
            slide = 0;
        }

        return slide;
    },

    updateSliders() {
        setTimeout(
            function() {
                this.updateSlider();
                this.updateThumbsSlider();
            }.bind(this),
            250,
        );
    },

    updateSlider() {
        if (this.galleryTop) {
            this.galleryTop.update();
        } else this.initTopSwiper();

        const slide = this.getCurrentSlideIndex();
        this.setActiveSlide(slide);
    },

    updateThumbsSlider() {
        const slide = this.getCurrentSlideIndex();

        if (this.galleryThumbs) {
            this.galleryThumbs.detachEvents();
            this.galleryThumbs.destroy();
            this.galleryThumbs = null;
        }

        if (this.checkThumbsFitness()) {
            this.galleryThumbsWrapper.addClass('thumbs-fit');
        } else {
            this.galleryThumbsWrapper.removeClass('thumbs-fit');
            this.initThumbsSwiper();
        }

        this.updateGalleryThumbsSlides(slide);

        if (this.galleryThumbs) {
            this.galleryThumbs.slideTo(slide);
        }
    },

    checkThumbsFitness() {
        const thumbsWidth = this.galleryThumbsContainer
            .find('.swiper-slide')
            .toArray()
            .reduce(
                (prev, el) =>
                    prev +
                    this.element.width() +
                    (prev > 0 ? THUMBS_SLIDE_SPACE : 0),
                0,
            );

        return thumbsWidth <= this.galleryThumbsContainer.width();
    },

    thumbSlideClick(el) {
        const index = $(el).index();

        if (this.galleryTop) {
            this.galleryTop.slideTo(index);
        }
        this.setActiveSlide(index);
    },

    toggleSlideInfo() {
        const $el = this.viewModel.attr('element');
        const imageInfoContainer = this.viewModel.attr('imageInfoContainer');

        $el.toggleClass('is-hidden-description');
        $el.hasClass('is-hidden-description')
            ? imageInfoContainer.fadeOut({ duration: 150, easing: 'linear' })
            : imageInfoContainer.fadeIn({ duration: 150, easing: 'linear' });
    },

    removeAd() {
        if (!this.attr('isAdsAdded')) {
            return;
        }

        const slideIndex = this.galleryTopContainer
            .find('.swiper-slide.ad')
            .index();

        this.galleryTop.removeSlide(slideIndex);
        this.galleryTop.update();
        this.galleryTop.updateSlides();
        if (this.galleryThumbs) {
            this.galleryThumbs.removeSlide(slideIndex);
            this.galleryThumbs.update();
            this.galleryThumbs.updateSlides();
        }
        const slide = this.getCurrentSlideIndex();
        this.setActiveSlide(slide);
        this.attr('isAdsAdded', false);
    },

    getFocusableSelector() {
        return 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), div[role="button"], iframe';
    },

    getFirstFocusableEl() {
        const topFocusableEls = this.element
            .find('.s-gallery-control')
            .find(this.getFocusableSelector());
        return topFocusableEls[0];
    },

    isMiddleSliderAvailable() {
        return (
            this.element
                .find('.s-tag-based-related-content-slider')
                .is(':visible') &&
            !this.element.hasClass('is-hidden-description')
        );
    },

    showAllThumbSlides() {
        this.$galleryThumbsContainer
            .find('.swiper-slide')
            .find('a')
            .attr('tabindex', '0');
        this.$galleryThumbsContainer
            .find('.swiper-slide')
            .find('button')
            .attr('tabindex', '0');
    },

    getLastFocusableEl() {
        let focusableEls = this.galleryTopContainer
            .find(this.getFocusableSelector())
            .not('.swiper-button-disabled');

        if (this.galleryThumbsWrapper.is(':visible')) {
            if (this.galleryThumbsWrapper.hasClass('thumbs-fit')) {
                this.showAllThumbSlides();
                focusableEls = this.galleryThumbsWrapper
                    .find('.gallery-thumbs')
                    .find(this.getFocusableSelector());
            } else {
                focusableEls = this.galleryThumbsWrapper
                    .find(this.getFocusableSelector())
                    .not('.swiper-button-disabled');
            }
        } else if (this.isMiddleSliderAvailable()) {
            focusableEls = this.element
                .find('.s-tag-based-related-content-slider')
                .find(this.getFocusableSelector())
                .not('.swiper-button-disabled');
        }

        return focusableEls[focusableEls.length - 1];
    },

    trapFocus() {
        this.element.off('keydown');
        const KEY_CODE_TAB = 9;
        const firstFocusableEl = this.getFirstFocusableEl();
        const lastFocusableEl = this.getLastFocusableEl();
        const handleTab = (e) => {
            const isTabPressed = e.key === 'Tab' || e.keyCode === KEY_CODE_TAB;
            if (!isTabPressed) {
                return;
            }
            if (e.shiftKey) {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        };

        this.element.on('keydown', handleTab);
    },

    config: {
        get: function() {
            return {
                imgPath: _.get(window, 'globalSettings.imgPath', ''),
            };
        },
    },
});

Component.extend({
    viewModel: Model,
    template: template,
    leakScope: false,
    tag: 'modal-photo-gallery',
    events: {
        inserted: function($component) {
            DomEventsManager.subscribe(this);

            const $el = $component.find('.c-modal-photo-gallery');

            this.viewModel.attr('component', $component);
            this.viewModel.attr('element', $el);
            this.viewModel.attr(
                'galleryTopContainer',
                $el.find('.swiper-container.gallery-top'),
            );
            this.viewModel.attr(
                'imageInfoContainer',
                $el.find('.s-image-info'),
            );
            this.viewModel.attr('imageTitle', $el.find('.s-slide-title'));
            this.viewModel.attr('imageIndex', $el.find('.s-slide-index'));
            this.viewModel.attr(
                'imageIndexMessage',
                $el.find('.s-slide-index-message'),
            );
            this.viewModel.attr(
                'galleryThumbsWrapper',
                $el.find('.gallery-thumbs-wrapper'),
            );
            this.viewModel.attr(
                'galleryThumbsContainer',
                $el.find('.swiper-container.gallery-thumbs'),
            );
            this.viewModel.attr('slidesCount', this.viewModel.photos.length);

            this.viewModel.galleryTopContainer
                .find('.swiper-slide')
                .each((i, el) =>
                    can
                        .$('.s-slide-desc-item--position', el)
                        .html(`${i + 1} of ${this.viewModel.slidesCount}`),
                );

            if (this.viewModel.slidesCount > 1) {
                this.viewModel.initTopSwiper();
            } else {
                $el.addClass('single-slide');

                if (!this.viewModel.attr('photos.0.image.caption')) {
                    $el.addClass('no-description');
                }
            }

            this.viewModel.attr('active', true);

            appContext.model.dispatch('page-scroll-toggle', [true]);

            this.viewModel.updateSliders();

            setTimeout(() => {
                this.viewModel.galleryTopContainer
                    .find('image-cloudinary')
                    .each(function(i, component) {
                        can.$(component)
                            .viewModel()
                            .recalculateSize(component);
                        can.$(component)
                            .viewModel()
                            .show();
                    });
                this.element.find('.s-gallery-hidden-start-focus').focus();
            }, 250);
        },

        removed: function() {
            this.viewModel.dispatch('modalGalleryClosed', [
                this.viewModel.attr('activeIndex'),
            ]);
            DomEventsManager.unsubscribe(this);
        },

        onWindowResize() {
            if (this.viewModel.active) {
                this.viewModel.updateSliders();
            }
        },

        '{document} keyup'(element, event) {
            if (event.keyCode === 27 && this.viewModel.attr('active')) {
                this.viewModel.hide();
            }
        },
    },
});
